import { gql } from '@grandvisionhq/graphql';

const deliveryEstimation = gql`
  fragment DeliveryEstimationFragment on LineItemDeliveryEstimation {
    earliestDeliveryDate
    latestDeliveryDate
  }
`;

export { deliveryEstimation };
//# sourceMappingURL=delivery-estimation.js.map
